// @flow

export type LanguageKey = 'fr' | 'en' | 'lu' | 'de' | 'pt' | 'nl';

export const defaultLanguage: LanguageKey = 'en';

export const availableLanguages: LanguageKey[] = [
   'fr',
   'de',
   'en',
   'lu',
   'pt',
   'nl',
];
